export default "__VITE_ASSET__a97a5552__"